module.exports = __webpack_public_path__ + "img/section4Logo3.57c7ae2b.webp";